import React, { useMemo, useRef } from 'react';
import {observer } from 'mobx-react';
import {PlayerEvents, DotLottieCommonPlayer} from '@dotlottie/react-player';
import {useServices } from '../../react-hooks/use-services.hook';
import {TitanJackpotWidgetConfiguration } from '../../services/configurations/config-data-sections/titan-jackpot-widget.configuration';
import {DotLottiePlayer} from '../lottie-player/dot-lottie-player.component';

const ANIMATION_PAUSE_INTERVAL = 3000;

const MINOR_JACKPOT_FRAME = 10;
const MAJOR_JACKPOT_FRAME = 90;
const MEGA_JACKPOT_FRAME = 180;

const ANIMATION_FRAME_STOPS = [MINOR_JACKPOT_FRAME, MAJOR_JACKPOT_FRAME, MEGA_JACKPOT_FRAME];

interface ITitanAnimationComponentProps {
    widgetConfig: TitanJackpotWidgetConfiguration;
}

export const TitanJackpotAnimationComponent: React.FC<ITitanAnimationComponentProps> = observer((props) => {
    let lottieRef = useRef<DotLottieCommonPlayer>(null);
    let animationCounter = 0;

    const services = useServices();

    const styles = useMemo(() => ({ borderRadius: 10, display: 'grid' }), []);

    const updateAnimationCounter = (): void => {
        animationCounter++;
    }

    const getTitanJackpotIndex = (): number => {
        return animationCounter % props.widgetConfig?.jackpotIds.length;
    }

    const getCurrentJackpotId = (): string => {
        const index: number = getTitanJackpotIndex();

        return String(props.widgetConfig.jackpotIds[index]);
    }

    const handleEnterFrame = (currentFrame: number): void => {
        if (Math.round(currentFrame) === ANIMATION_FRAME_STOPS[getTitanJackpotIndex()]) {
            lottieRef.current.pause();

            services.titanJackpot.updateJackpotHandler(getCurrentJackpotId());

            setTimeout(() => {
                lottieRef.current.play();
            }, ANIMATION_PAUSE_INTERVAL);

            updateAnimationCounter();
        }
    };

    const onEventHandler = (event: PlayerEvents, params: unknown) => {
        /**
         * Intercept any event from PlayerEvents in here
         * Example: Listen for player ready
         * if (event === PlayerEvents.Ready) { do stuff here }
         * Listening for frame change
         * if (event === PlayerEvents.Frame) {
         */
        if (event === PlayerEvents.Frame) {
            handleEnterFrame((params as Record<string, number>).frame)
        }
    }

    return (
        <DotLottiePlayer
            onEvent={onEventHandler}
            src={services.theme.currentTheme.images.lottieAnimation.titanJackpot.toString()}
            ref={lottieRef}
            autoplay
            loop
            style={styles}
        />
    )
});
